import React from "react";
import { Redirect } from 'react-router-dom';
import { Form, Input, Button, Card, Alert, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { connect } from 'react-redux';
import { forgotPassword } from "../actions/userActions";

import logo from '../images/logo_large.png'

class ForgotPassword extends React.Component {

  state = {
    redirectToReferrer: false
  }

  handleSubmit = values => {
    const { email } = values;
    this.props.dispatch(forgotPassword(email));
  };

  render() {
    const { error, loading } = this.props;

    return (
      <div className="login-container">
        <Card title="Recover Password" style={{ width: 300 }}>
          {error ? <Alert message="Invalid email or password" type="error" style={{ marginBottom: '1em' }} /> : ''}
          <Form layout='vertical' onFinish={this.handleSubmit}>
            <img src={logo} style={{ marginBottom: '2em' }} alt="Umbrella" />
            <Form.Item name="email" rules={[{ required: true, message: 'Please enter your username' }]}>
              <Input
                prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Email"
              />
            </Form.Item>
            <Button block type="primary" htmlType="submit" className="login-form-button" disabled={loading}>
              Email instructions
            </Button>
            <div style={{marginTop: '1rem'}}></div>
            <div>
              <a style={{ float: 'left' }} href="/login">
                Login
              </a>
            </div>
          </Form>
        </Card>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  user: state.auth.user,
  loading: state.auth.loading,
  error: state.auth.error
});
export default connect(mapStateToProps)(ForgotPassword);